import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue';
import SvgIcon from '../../common/base/SvgIcon.vue';
import { useRoomStore } from '../../../stores/room';
import useRoomControl from './useRoomControlHooks';
import '../../../directives/vTap';
import CreateRoomIcon from '../../common/icons/CreateRoomIcon.vue';
import EnterRoomIcon from '../../common/icons/EnterRoomIcon.vue';
import ArrowStrokeBackIcon from '../../common/icons/ArrowStrokeBackIcon.vue';
import ArrowStrokeSelectDownIcon from '../../common/icons/ArrowStrokeSelectDownIcon.vue';
import Logo from '../../common/Logo.vue';
import TUIMessage from '../../common/base/Message/index';

interface Props{
  userName: string
  givenRoomId: string | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RoomControlH5',
  props: {
    userName: null,
    givenRoomId: null
  },
  emits: ['create-room', 'enter-room', 'update-user-name'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  userName: string
  givenRoomId: string | null
}

const {
  t,
} = useRoomControl();

const moreTypeRef = ref();
const roomStore = useRoomStore();
const showRoomDetail = ref(false);
const showMoreType = ref(false);
const isJoinRoom = ref(false);
const roomType =  computed(() => (mode.value === 'FreeToSpeak' ? t('Free Speech Room') : t('On-stage Speaking Room')));
const isMicOn = ref(true);
const isCamerOn = ref(true);
const mode = ref('FreeToSpeak');
const roomId = ref('');
const tuiRoomParam = {
  isOpenCamera: true,
  isOpenMicrophone: true,
  defaultCameraId: '',
  defaultMicrophoneId: '',
  defaultSpeakerId: '',
};



expose({
  getRoomParam,
});
const currentUserName = ref(props.userName ||  `user_${Math.ceil(Math.random() * 10)}`);
const hasGivenRoomId = computed(() => (typeof props.givenRoomId === 'string' && props.givenRoomId !== ''));

watch(
  () => props.givenRoomId,
  (val) => {
    if (val) {
      roomId.value = val;
    }
  },
  { immediate: true },
);

function createRoom() {
  showRoomDetail.value = !showRoomDetail.value;
  isJoinRoom.value = false;
}
function enterRoom() {
  showRoomDetail.value = !showRoomDetail.value;
  isJoinRoom.value = true;
}
function chooseRoomType() {
  showMoreType.value = !showMoreType.value;
}
function chooseCurrentType(roomType: string) {
  mode.value = roomType;
}
function handleConfirm() {
  showMoreType.value = !showMoreType.value;
}
function handleClose() {
  showRoomDetail.value = false;
  showMoreType.value = false;
}
function toggle(type:string) {
  switch (type) {
    case 'isMicOn':
      isMicOn.value = !isMicOn.value;
      tuiRoomParam.isOpenMicrophone = isMicOn.value;
      break;
    case 'isCamerOn':
      isCamerOn.value = !isCamerOn.value;
      tuiRoomParam.isOpenCamera = isCamerOn.value;
      break;
    default:
      break;
  }
}
function getRoomParam() {
  tuiRoomParam.defaultCameraId = roomStore.currentCameraId;
  tuiRoomParam.defaultMicrophoneId = roomStore.currentMicrophoneId;
  tuiRoomParam.defaultSpeakerId = roomStore.currentSpeakerId;
  return tuiRoomParam;
}

function handleInput(e: any) {
  roomId.value = e.target.value;
}

function handleInputName(e: any) {
  currentUserName.value = e.target.value;
}

function handleDocumentClick(event: MouseEvent) {
  if (showMoreType.value && !moreTypeRef.value.contains(event.target)) {
    showMoreType.value = false;
  }
}


function handleRoomOption(type:string) {
  emit('update-user-name', currentUserName.value);
  switch (type) {
    case 'Join':
      if (!roomId.value) {
        TUIMessage({ type: 'error', message: t('Please enter the room number') });
        return;
      }
      emit('enter-room', String(roomId.value));
      break;
    case 'New':
      emit('create-room', mode.value);
      break;
    default:
      break;
  }
}


onMounted(() => {
  document?.addEventListener('click', handleDocumentClick, true);
});

onUnmounted(() => {
  document?.removeEventListener('click', handleDocumentClick, true);
});


return { __sfc: true,t, moreTypeRef, roomStore, showRoomDetail, showMoreType, isJoinRoom, roomType, isMicOn, isCamerOn, mode, roomId, tuiRoomParam, emit, props, currentUserName, hasGivenRoomId, createRoom, enterRoom, chooseRoomType, chooseCurrentType, handleConfirm, handleClose, toggle, getRoomParam, handleInput, handleInputName, handleDocumentClick, handleRoomOption, SvgIcon, CreateRoomIcon, EnterRoomIcon, ArrowStrokeBackIcon, ArrowStrokeSelectDownIcon, Logo }
}

})